import React, { useCallback } from "react";
import { Tooltip } from "antd";
import { CommentOutlined } from "@ant-design/icons";
import { useFeedback } from "./FeedbackContext";

/**
 * Petit déclencheur contextuel : icône fantôme, visible au hover du parent.
 * Le parent doit avoir la classe "has-inline-feedback" pour que le trigger apparaisse au hover.
 */
const InlineFeedbackTrigger = ({
    featureArea,
    targetType,
    targetId = null,
    aiCommentId = null,
    contextJson = null,
    badgeLabel = null,
    presetReason = null,
    tooltip = "Signaler / donner un avis",
    placement = "top",
    className = "",
    stopPropagation = true,
    ariaLabel,
}) => {
    const { openFeedback } = useFeedback();

    const handleClick = useCallback((event) => {
        if (stopPropagation) {
            event.stopPropagation();
            event.preventDefault();
        }
        openFeedback({
            featureArea,
            targetType,
            targetId,
            aiCommentId,
            contextJson: { source: "inline_trigger", ...(contextJson || {}) },
            badgeLabel,
            presetReason,
        });
    }, [openFeedback, featureArea, targetType, targetId, aiCommentId, contextJson, badgeLabel, presetReason, stopPropagation]);

    return (
        <Tooltip title={tooltip} placement={placement} mouseEnterDelay={0.25}>
            <button
                type="button"
                className={`inline-feedback-trigger ${className}`.trim()}
                onClick={handleClick}
                aria-label={ariaLabel || tooltip}
            >
                <CommentOutlined />
            </button>
        </Tooltip>
    );
};

export default InlineFeedbackTrigger;

